var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 43,
    viewBox: "0 0 37 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_473_2578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.224121 37.9741H36.2238V0.863281H0.224121V37.9741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.223633 37.9746H36.2236V42.3007H0.22398L0.223633 37.9746Z",
    fill: "#010314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5101 10.6289L2.45874 28.6773H6.84009L10.9503 15.9201L13.0104 22.298H10.3455L9.28126 25.9388H14.1864L15.0709 28.6773H19.5775L13.5268 10.6289H8.5101ZM26.4624 10.6289H20.172V28.6773H24.5221V14.2698H26.275C28.3089 14.2698 29.467 15.2342 29.467 16.9769C29.467 18.6884 28.3089 19.6842 26.275 19.6842H25.9934V23.325H26.4624C31.1568 23.325 33.9108 20.9754 33.9108 16.9769C33.9108 12.9005 31.1568 10.6289 26.4624 10.6289Z",
    fill: "#010314"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_473_2578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 42,
    fill: "white",
    transform: "translate(0.223633 0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAp);
export default __webpack_public_path__ + "static/media/AP.a6558d1522e99a4a491dfb57fd029e87.svg";
export { ForwardRef as ReactComponent };